//
//
//
//

import axios from 'axios'
import wcs from '@/scripts/libs/wcs'
import PromoStripe from '../libs/promo-stripe/promo-stripe'
import { PROMOCODE } from '@/scripts/constants/promos'

export default {
  name: 'rb-promo-substitute',
  props: {
    paramField: {
      default: '',
      type: String,
    },
  },
  data: function () {
    return {
      promoField: undefined,
    }
  },
  mounted() {
    const promoCodeFromSessionStorage = sessionStorage.getItem('promoCodeToApplyEvaluateQuery')
    const promoCodeToApply =
      PromoStripe.getPromoCode(window.location.search) || promoCodeFromSessionStorage
    if (promoCodeToApply) {
      this.retrieveField(promoCodeToApply)
    }
  },
  methods: {
    retrieveField(promoParam) {
      if (this.paramField === PROMOCODE) {
        this.promoField = promoParam
      } else {
        const urlPromoApi = wcs.getEndPoint('promotionDetails').replace('{promo}', promoParam)
        axios.get(urlPromoApi).then(({ data }) => {
          const promoObject = this.flattenObj(data.promotionDetails)
          this.promoField = promoObject[this.paramField]
        })
      }
    },
    flattenObj(obj, res = {}) {
      for (let key in obj) {
        if (typeof obj[key] == 'object') {
          this.flattenObj(obj[key], res)
        } else {
          res[key] = obj[key]
        }
      }
      return res
    },
  },
}
